// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.dashboard[data-v-38732c1e] {\n    padding: 20px;\n}\n.chart-container[data-v-38732c1e] {\n    height: 400px;\n    width: 100%;\n}\n.chart[data-v-38732c1e] {\n    height: 100%;\n    width: 100%;\n}\npre[data-v-38732c1e] {\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
